export default __webpack_public_path__ + "static/media/close-circle.242cecb9.svg";